/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Status_AllInputs */

const vi_order_status_all = /** @type {(inputs: Order_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả trạng thái`)
};

/**

* @param {Order_Status_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_status_all = /** @type {((inputs?: Order_Status_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Status_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_status_all(inputs)
});